var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M18 7.5V3.315c0-.675.81-1.005 1.275-.525l5.7 5.685c.3.3.3.765 0 1.065l-5.685 5.685c-.48.465-1.29.135-1.29-.54V10.5a9.004 9.004 0 0 0-8.79 10.935c.705 3.405 3.465 6.15 6.855 6.855a9.022 9.022 0 0 0 10.845-7.515 1.499 1.499 0 0 1 1.47-1.275c.9 0 1.62.795 1.5 1.695a12.02 12.02 0 0 1-14.295 10.08c-4.68-.915-8.445-4.68-9.36-9.36C4.74 14.22 10.59 7.5 18 7.5Z"
});

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16.333 24h-1.298v-4.884h-1.727v-.902c.499-.007.917-.136 1.254-.385.337-.257.546-.576.627-.957h1.144V24Zm1.208-1.969 1.243-.319c.03.389.176.708.44.957.264.25.598.374 1.001.374.382 0 .7-.117.957-.352.264-.242.396-.557.396-.946 0-.418-.132-.74-.396-.968-.264-.235-.59-.352-.979-.352-.498 0-.894.165-1.188.495l-1.243-.45.88-3.598h3.905v1.155h-3.014l-.44 1.804c.316-.33.77-.495 1.364-.495.726 0 1.313.213 1.76.638.455.425.682 1.005.682 1.738 0 .69-.245 1.272-.737 1.75-.49.476-1.14.714-1.947.714-.748 0-1.37-.209-1.87-.627-.498-.425-.77-.931-.814-1.518Z"
});

var SvgIconFastForward15 = function SvgIconFastForward15(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 36",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconFastForward15, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-fast-forward-15.a63a71b8.svg";
export { ForwardRef as ReactComponent };